import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/main/app/[country]/[lang]/PathLocaleSync.tsx");
